import useMutationUserCreateUpdate from './user-use-mutation-create-update';
import useMutationUserSendPass from "./user-use-mutation-send-password";
import useMutationUserImportReimport from "./user-use-mutation-import";
import useMutationUserDelete from "./user-use-mutation-delete";
import useMutationUserQuestionCreateUpdate from "./user-question-use-mutation-create-update";
import useMutationUserQuestionDelete from "./user-question-use-mutation-delete";


export const userUseMutation = {
  createUpdate: useMutationUserCreateUpdate,
  sendPass: useMutationUserSendPass,
  importReimport: useMutationUserImportReimport,
  delete: useMutationUserDelete,
  questionCreateUpdate: useMutationUserQuestionCreateUpdate,
  questionDelete: useMutationUserQuestionDelete,
}